module.exports = __webpack_public_path__ + "static/media/x-white.38ab49ae.svg";